import { gameMapsClientModule } from "./game-maps/game-maps.module";
import { supportClientModule } from "./support/support.module";
import type { OmnisyniaClientModule } from "./module.types";
import { accountClientModule } from "./account/account.module";
import { chatOmnisyniaClientModule } from "./chat-omnisynia/chat-omnisynia.module";
import { omniWikiClientModule } from "./omni-wiki/omni-wiki.module";
import { ultraClientModule } from "./ultra/ultra.module";

import { teacherClientModule } from "./teacher/teacher.module";

const registeredModules = [
  chatOmnisyniaClientModule,
  omniWikiClientModule,
  teacherClientModule,
  gameMapsClientModule,
  accountClientModule,
  supportClientModule,
  ultraClientModule
] as const;

export const moduleRegistry: readonly OmnisyniaClientModule[] = Object.freeze(
  registeredModules
);

export function getClientModule(moduleId: string): OmnisyniaClientModule | undefined {
  return moduleRegistry.find((module) => module.id === moduleId);
}

